import { io } from "socket.io-client";

export const socket = io(
  "http://ec2-63-34-136-219.eu-west-1.compute.amazonaws.com:8000",
);
